export const storeKey = "mgAnalytic";
